// extracted by mini-css-extract-plugin
module.exports = {"promoBlock":"Cbt9A","image":"_2FdXj"};